export const translations = {
  de: {
    nav: {
      home: "Home",
      reformer: "Reformer",
      equipment: "Equipment",
      studios: "Für Studios",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Angebot anfragen",
      menu: "Menü",
      close: "Schließen",
    },
    common: {
      quote: "Angebot anfragen",
      details: "Details ansehen",
      back: "Zurück",
      material: "Material",
      dims: "Maße",
      finishesLabel: "Editionen",
      edition: "Edition",
      outfitting: "Ausstattung",
      priceOnRequest: "Preis auf Anfrage",
      discover: "{x} entdecken",
      onRequest: "Auf Anfrage",
      placeholder: "Platzhalter",
      required: "Pflichtfeld",
      sending: "Wird gesendet …",
      formError: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    },
    home: {
      heroLines: ["PILATES ON.", "WORLD OFF."],
      heroSub: "Premium Pilates Equipment für Studios & anspruchsvolle Private Spaces.",
      heroCtaPrimary: "Kollektion entdecken",
      heroCtaSecondary: "Angebot anfragen",
      scroll: "Scrollen",
      marquee: ["PILATES ON.", "WORLD OFF.", "MADE FOR STUDIOS.", "DESIGNED FOR MOVEMENT.", "CRAFTED FOR SPACE."],
      philosophyOverline: "Philosophie",
      philosophyTitle: ["PILATES ON.", "WORLD OFF."],
      philosophyLead: "Ein Moment, in dem nur Bewegung zählt.",
      philosophyText:
        "PILATES ON. verbindet hochwertiges Pilates Equipment mit klarer Ästhetik und durchdachtem Design. Für Studios, professionelle Trainingsräume und Menschen, die Bewegung und Gestaltung gleichermaßen schätzen.",
      philosophyLink: "Über uns",
      reformerOverline: "Reformer",
      reformerTitle: ["THE", "REFORMER."],
      reformerText: "Classic, Tower und Combo Cadillac. Massives Hainbuchenholz, klare Linien – in fünf Editionen.",
      reformerCta: "Reformer entdecken",
      editionsOverline: "Editionen",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "Fünf Ausführungen, ein Reformer. Die Edition bestimmt Farbe und Material – Modell und Technik bleiben identisch.",
      studiosOverline: "Für Studios",
      studiosTitle: ["MADE FOR", "STUDIOS."],
      studiosText:
        "Vom ersten Reformer bis zur kompletten Studioausstattung: Wir statten Pilates-Studios, Physiotherapiepraxen, Personal Trainer, Hotels und Wellnessbereiche aus – mit einheitlichem Design, drei Reformer-Modellen in fünf Editionen und persönlicher Beratung.",
      studiosCta: "Studio-Ausstattung anfragen",
      studiosLink: "Mehr für Studios",
      ctaOverline: "Anfrage",
      ctaTitle: ["ANGEBOT", "ANFRAGEN."],
      ctaText: "Erzähl uns von deinem Raum und deinem Bedarf – wir melden uns persönlich.",
      ctaBtn: "Angebot anfragen",
    },
    reformer: {
      overline: "Reformer",
      title: ["REFORMER"],
      sub: "Designed for movement.",
      intro: "Drei Modelle. Massives Hainbuchenholz. Fünf Editionen.",
      modelsOverline: "Modelle",
      editionsOverline: "Editionen",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "Die Edition bestimmt Farbe und Material – Modell und Technik bleiben identisch.",
      hint: "Die Auswahl gilt für alle Modelle. Farbdarstellung kann abweichen.",
      shown: "Abgebildet",
    },

    detail: {
      back: "Alle Reformer",
      chooseFinish: ["CHOOSE YOUR", "EDITION."],
      finishHint: "Modell und Edition werden automatisch in deine Anfrage übernommen.",
      selected: "Ausgewählt",
      gallery: "Galerie",
      galleryHint: "Alle Editionen im Überblick – ein Klick wählt die Edition.",
      details: "Technische Daten",
      specsNote: "Weitere Ausstattungsdetails auf Anfrage.",
      craftOverline: "Qualität & Materialien",
      craftTitle: ["CRAFTED", "FOR MOVEMENT."],
      offerOverline: "Anfrage",
      offerTitle: ["PREIS AUF", "ANFRAGE."],
      offerText: "Keine Listenpreise: Du erhältst ein persönliches Angebot – abgestimmt auf Stückzahl, Edition und Projekt.",
      offerBtn: "Angebot anfragen",
    },
    equipment: {
      overline: "Equipment",
      title: ["MORE THAN", "REFORMER."],
      sub: "Ladder Barrel, Combo Chair, Springwall und Spine Corrector – in derselben Formsprache wie unsere Reformer.",
      enquire: "Angebot anfragen",
      specs: "Technische Angaben",
    },
    studios: {
      overline: "Für Studios",
      title: ["YOUR STUDIO.", "YOUR WAY."],
      heroText: "Equipment für professionelle Räume. Ob neues Studio oder Erweiterung – wir unterstützen bei der Auswahl einer passenden Ausstattung.",
      audiencesOverline: "Für wen",
      audiences: ["Pilates-Studios", "Physiotherapiepraxen", "Personal Trainer", "Hotels", "Wellnessbereiche", "Professionelle Trainingsräume"],
      focusOverline: "Worauf es ankommt",
      focus: [
        { t: "PROFESSIONELLES EQUIPMENT", d: "Reformer und Geräte aus massivem Hainbuchenholz – für den täglichen Einsatz im Studio." },
        { t: "EIN DURCHGÄNGIGES BILD", d: "Alle Modelle in derselben Edition – für ein ruhiges, einheitliches Studiodesign." },
        { t: "PERSÖNLICHE BERATUNG", d: "Produktauswahl, Edition und Stückzahl – abgestimmt auf Raum und Konzept." },
      ],
      processOverline: "Der Weg zum Angebot",
      steps: [
        { n: "01", t: "REFORMER WÄHLEN", d: "Classic, Tower oder Combo Cadillac – passend zu Raum und Konzept." },
        { n: "02", t: "EDITION WÄHLEN", d: "Natural, Walnut, Ivory, Obsidian oder Blush – eine Edition für dein Studio." },
        { n: "03", t: "STÜCKZAHL FESTLEGEN", d: "Vom einzelnen Reformer bis zur kompletten Ausstattung." },
        { n: "04", t: "PROJEKT ANFRAGEN", d: "Du erhältst ein individuelles Angebot für dein Projekt." },
      ],
      editionsOverline: "Editionen",
      editionsTitle: ["EINE EDITION.", "EIN STUDIO."],
      editionsText: "Alle Reformer-Modelle sind in fünf Editionen erhältlich – für ein durchgängiges Studiobild.",
      cta: "Projekt anfragen",
      formOverline: "Projektanfrage",
      formTitle: ["ERZÄHL UNS VON", "DEINEM PROJEKT."],
      firstName: "Vorname",
      lastName: "Nachname",
      company: "Unternehmen / Studio",
      email: "E-Mail",
      phone: "Telefon",
      location: "Ort / PLZ",
      needed: "Was wird benötigt?",
      quantity: "Gewünschte Stückzahl",
      opening: "Geplanter Eröffnungstermin / Bedarf",
      message: "Nachricht",
      submit: "Projekt anfragen",
    },
    about: {
      overline: "Über uns",
      title: ["MOVEMENT.", "DESIGN.", "QUALITY."],
      p1: "PILATES ON. steht für Pilates Equipment, das Bewegung und Gestaltung verbindet.",
      p2: "Wir glauben, dass professionelles Equipment nicht nur funktionieren, sondern Teil eines Raumes sein sollte – präzise in der Funktion, ruhig in der Form.",
      p3: "Dafür setzen wir auf Reformer aus massivem Hainbuchenholz, reduzieren auf das Wesentliche und beraten persönlich. Für Studios, professionelle Trainingsräume und Menschen, die Bewegung und Design gleichermaßen schätzen.",
      principlesOverline: "Wofür wir stehen",
      principles: [
        { t: "BEWEGUNG", d: "Equipment, das den Fokus auf die Bewegung lenkt – und alles andere leiser werden lässt." },
        { t: "DESIGN", d: "Klare Linien und warme Materialien, die sich in jeden Raum einfügen." },
        { t: "QUALITÄT", d: "Massives Hainbuchenholz, sorgfältig verarbeitete Verbindungen und Polster." },
        { t: "FUNKTION", d: "Drei Reformer-Modelle und ergänzende Geräte für professionelles Training." },
        { t: "ÄSTHETIK", d: "Fünf Editionen, ein Anspruch: weniger, aber besser." },
      ],
      captions: ["Hainbuchenholz", "Polsterung", "Studio", "Combo Cadillac Reformer"],
      cta: "Kontakt aufnehmen",
    },
    contact: {
      overline: "Kontakt",
      title: ["KONTAKT."],
      sub: "Fragen zu Produkten oder Projekten? Wir melden uns persönlich – auf Deutsch oder Englisch.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      company: "Unternehmen",
      message: "Nachricht",
      submit: "Anfrage senden",
      infoTitle: "Direkter Draht",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      address: "Firmensitz",
      emailValue: "office@pilateson.de",
      addressValue: "Kapellenstraße 55\n88471 Laupheim\nDeutschland",
    },
    inquiry: {
      overline: "Individuelles Angebot",
      title: ["ANGEBOT", "ANFRAGEN."],
      sub: "Unverbindlich und persönlich – wir melden uns mit einem maßgeschneiderten Angebot bei dir.",
      summary: "Deine Auswahl",
      noProduct: "Noch kein Produkt gewählt",
      product: "Produkt",
      finish: "Edition",
      quantity: "Stückzahl",
      category: "Kundentyp",
      categories: ["Pilates Studio", "Physiotherapie", "Personal Trainer", "Hotel / Wellness", "Privatkunde", "Sonstiges"],
      studioPackage: "Komplette Studioausstattung",
      select: "Bitte wählen",
      contactData: "Kontaktdaten",
      firstName: "Vorname",
      lastName: "Nachname",
      company: "Unternehmen / Studio",
      email: "E-Mail",
      phone: "Telefon",
      location: "PLZ / Ort",
      message: "Nachricht",
      submit: "Individuelles Angebot anfragen",
    },
    thanks: {
      title: ["VIELEN", "DANK."],
      text: "Wir haben deine Anfrage erhalten und melden uns persönlich bei dir.",
      home: "Zurück zur Startseite",
    },
    admin: {
      overline: "Intern",
      loginTitle: "Admin Login",
      email: "E-Mail",
      password: "Passwort",
      loginBtn: "Anmelden",
      loginError: "Anmeldung fehlgeschlagen. Bitte Zugangsdaten prüfen.",
      dashboard: "Anfragen",
      logout: "Abmelden",
      filterAll: "Alle",
      filterQuote: "Angebote",
      filterStudio: "Studio",
      filterContact: "Kontakt",
      statuses: { new: "Neu", contacted: "In Kontakt", offered: "Angebot gesendet", closed: "Erledigt" },
      empty: "Noch keine Anfragen eingegangen.",
      exportCsv: "CSV Export",
      received: "Eingegangen",
      quantity: "Stückzahl",
      items: "Produkte",
      loadError: "Anfragen konnten nicht geladen werden.",
    },
    legal: {
      placeholderBox:
        "PLATZHALTER — Diese Seite wird vor Veröffentlichung mit den rechtlich erforderlichen Angaben ergänzt. Es sind bewusst noch keine Unternehmensdaten hinterlegt.",
      impressum: { title: ["IMPRESSUM"], note: "Angaben gemäß § 5 TMG folgen." },
      datenschutz: { title: ["DATENSCHUTZ", "ERKLÄRUNG"], note: "Datenschutzerklärung gemäß DSGVO folgt." },
      agb: { title: ["AGB"], note: "Allgemeine Geschäftsbedingungen folgen." },
      widerruf: { title: ["WIDERRUFS", "BELEHRUNG"], note: "Widerrufsbelehrung folgt." },
    },
    seo: {
      home: ["PILATES ON. — Premium Pilates Reformer & Pilates Equipment", "Premium Pilates Reformer und Pilates Geräte für Studios, Physiotherapie und professionelle Trainingsräume. PILATES ON. WORLD OFF."],
      reformer: ["Pilates Reformer — Classic, Tower & Combo Cadillac | PILATES ON.", "Pilates Reformer aus massivem Hainbuchenholz in fünf Editionen. Reformer für Studios anfragen – Preis auf Anfrage."],
      equipment: ["Pilates Geräte — Ladder Barrel, Combo Chair, Springwall, Spine Corrector | PILATES ON.", "Pilates Equipment für Studios: Ladder Barrel, Combo Chair, Springwall und Spine Corrector. Angebot anfragen."],
      studios: ["Pilates Studio Ausstattung — Für Studios | PILATES ON.", "Pilates Studio Ausstattung für Studios, Physiotherapiepraxen, Personal Trainer und Hotels. Reformer, Editionen, Stückzahl – Projekt anfragen."],
      about: ["Über uns | PILATES ON.", "Die Philosophie hinter PILATES ON.: Bewegung, Design, Qualität, Funktion und Ästhetik."],
      contact: ["Kontakt | PILATES ON.", "Fragen zu Pilates Reformern oder Studio-Projekten? Kontakt aufnehmen – wir melden uns persönlich."],
      inquiry: ["Angebot anfragen | PILATES ON.", "Individuelles Angebot für Pilates Reformer und Equipment anfragen – Produkt, Edition und Stückzahl wählen."],
    },
    footer: {
      tagline: "Premium Pilates Equipment.",
      menuCol: "Menü",
      legalCol: "Rechtliches",
      contactCol: "Kontakt",
      note: "Abbildungen exemplarisch – Farbdarstellung kann abweichen. Alle Preise auf Anfrage.",
      admin: "Admin",
      rights: "© 2026 PILATES ON. Alle Rechte vorbehalten.",
      legal: { impressum: "Impressum", datenschutz: "Datenschutz", agb: "AGB", widerruf: "Widerrufsbelehrung" },
    },
  },
  en: {
    nav: {
      home: "Home",
      reformer: "Reformer",
      equipment: "Equipment",
      studios: "For Studios",
      about: "About",
      contact: "Contact",
      cta: "Request a Quote",
      menu: "Menu",
      close: "Close",
    },
    common: {
      quote: "Request a quote",
      details: "View details",
      back: "Back",
      material: "Material",
      dims: "Dimensions",
      finishesLabel: "Editions",
      edition: "Edition",
      outfitting: "Features",
      priceOnRequest: "Price on request",
      discover: "Discover {x}",
      onRequest: "On request",
      placeholder: "Placeholder",
      required: "Required field",
      sending: "Sending …",
      formError: "Something went wrong. Please try again.",
      invalidEmail: "Please enter a valid email address.",
    },
    home: {
      heroLines: ["PILATES ON.", "WORLD OFF."],
      heroSub: "Premium Pilates Equipment for Studios.",
      heroCtaPrimary: "For studios",
      heroCtaSecondary: "Request a quote",
      scroll: "Scroll",
      marquee: ["PILATES ON.", "WORLD OFF.", "DESIGNED FOR MOVEMENT.", "CRAFTED FOR SPACE."],
      philosophyOverline: "Philosophy",
      philosophyTitle: ["PILATES ON.", "WORLD OFF."],
      philosophyLead: "A moment in which only movement counts.",
      philosophyText:
        "PILATES ON. combines premium pilates equipment with clear aesthetics and considered design. For studios, professional training spaces and people who value movement and design equally.",
      philosophyLink: "About us",
      reformerOverline: "Reformer",
      reformerTitle: ["THE", "REFORMER."],
      reformerText: "Classic, Tower and Combo Cadillac. Solid hornbeam wood, clean lines – in five editions.",
      reformerCta: "Explore reformers",
      editionsOverline: "Editions",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "Five finishes, one reformer. The edition defines colour and material – model and engineering remain identical.",
      studiosOverline: "For studios",
      studiosTitle: ["MADE FOR", "STUDIOS."],
      studiosText:
        "From the first reformer to the complete studio fit-out: we equip pilates studios, physiotherapy practices, personal trainers, hotels and wellness areas – with a coherent design, three reformer models in five editions and personal advice.",
      studiosCta: "Request studio equipment",
      studiosLink: "More for studios",
      ctaOverline: "Enquiry",
      ctaTitle: ["REQUEST", "A QUOTE."],
      ctaText: "Tell us about your space and your needs – we will get back to you personally.",
      ctaBtn: "Request a quote",
    },
    reformer: {
      overline: "Reformer",
      title: ["REFORMER"],
      sub: "Designed for movement.",
      intro: "Three models. Solid hornbeam wood. Five editions.",
      modelsOverline: "Models",
      editionsOverline: "Editions",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "The edition defines colour and material – model and engineering remain identical.",
      hint: "Your selection applies to all models. Colours may vary from the display.",
      shown: "Shown",
    },

    detail: {
      back: "All reformers",
      chooseFinish: ["CHOOSE YOUR", "EDITION."],
      finishHint: "Model and edition are carried over to your enquiry automatically.",
      selected: "Selected",
      gallery: "Gallery",
      galleryHint: "All editions at a glance – click to select an edition.",
      details: "Specifications",
      specsNote: "Further specifications on request.",
      craftOverline: "Quality & Materials",
      craftTitle: ["CRAFTED", "FOR MOVEMENT."],
      offerOverline: "Enquiry",
      offerTitle: ["PRICE ON", "REQUEST."],
      offerText: "No list prices: you receive a personal quote – tailored to quantity, edition and project.",
      offerBtn: "Request a quote",
    },
    equipment: {
      overline: "Equipment",
      title: ["MORE THAN", "REFORMER."],
      sub: "Ladder Barrel, Combo Chair, Springwall and Spine Corrector – in the same design language as our reformers.",
      enquire: "Request a quote",
      specs: "Specifications",
    },
    studios: {
      overline: "For Studios",
      title: ["YOUR STUDIO.", "YOUR WAY."],
      heroText: "Equipment for professional spaces. Whether a new studio or an extension – we support you in selecting the right equipment.",
      audiencesOverline: "Who it's for",
      audiences: ["Pilates studios", "Physiotherapy practices", "Personal trainers", "Hotels", "Wellness areas", "Professional training spaces"],
      focusOverline: "What matters",
      focus: [
        { t: "PROFESSIONAL EQUIPMENT", d: "Reformers and apparatus in solid hornbeam wood – for daily use in the studio." },
        { t: "ONE COHERENT LOOK", d: "All models in the same edition – for a calm, unified studio design." },
        { t: "PERSONAL ADVICE", d: "Product selection, edition and quantity – matched to your space and concept." },
      ],
      processOverline: "The way to your quote",
      steps: [
        { n: "01", t: "CHOOSE YOUR REFORMER", d: "Classic, Tower or Combo Cadillac – matched to your space and concept." },
        { n: "02", t: "CHOOSE YOUR EDITION", d: "Natural, Walnut, Ivory, Obsidian or Blush – one edition for your studio." },
        { n: "03", t: "SET THE QUANTITY", d: "From a single reformer to a complete fit-out." },
        { n: "04", t: "REQUEST YOUR PROJECT", d: "You receive an individual quote for your project." },
      ],
      editionsOverline: "Editions",
      editionsTitle: ["ONE EDITION.", "ONE STUDIO."],
      editionsText: "All reformer models are available in five editions – for a consistent studio look.",
      cta: "Request a project",
      formOverline: "Project enquiry",
      formTitle: ["TELL US ABOUT", "YOUR PROJECT."],
      firstName: "First name",
      lastName: "Last name",
      company: "Company / Studio",
      email: "Email",
      phone: "Phone",
      location: "City / ZIP",
      needed: "What do you need?",
      quantity: "Desired quantity",
      opening: "Planned opening date / timeline",
      message: "Message",
      submit: "Request a project",
    },
    about: {
      overline: "About us",
      title: ["MOVEMENT.", "DESIGN.", "QUALITY."],
      p1: "PILATES ON. stands for pilates equipment that connects movement and design.",
      p2: "We believe professional equipment should not only perform, but become part of the room – precise in function, calm in form.",
      p3: "That is why we rely on reformers in solid hornbeam wood, reduce to the essential and advise personally. For studios, professional training spaces and people who value movement and design equally.",
      principlesOverline: "What we stand for",
      principles: [
        { t: "MOVEMENT", d: "Equipment that puts the focus on movement – and lets everything else fade." },
        { t: "DESIGN", d: "Clean lines and warm materials that fit into any space." },
        { t: "QUALITY", d: "Solid hornbeam wood, carefully crafted joints and upholstery." },
        { t: "FUNCTION", d: "Three reformer models and complementary apparatus for professional training." },
        { t: "AESTHETICS", d: "Five editions, one standard: less, but better." },
      ],
      captions: ["Hornbeam wood", "Upholstery", "Studio", "Combo Cadillac Reformer"],
      cta: "Get in touch",
    },
    contact: {
      overline: "Contact",
      title: ["CONTACT."],
      sub: "Questions about products or projects? We will get back to you personally – in German or English.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "Message",
      submit: "Send enquiry",
      infoTitle: "Direct line",
      emailLabel: "Email",
      phoneLabel: "Phone",
      address: "Registered office",
      emailValue: "office@pilateson.de",
      addressValue: "Kapellenstraße 55\n88471 Laupheim\nGermany",
    },
    inquiry: {
      overline: "Individual quote",
      title: ["REQUEST", "A QUOTE."],
      sub: "Non-binding and personal – we will get back to you with a tailor-made quote.",
      summary: "Your selection",
      noProduct: "No product selected yet",
      product: "Product",
      finish: "Edition",
      quantity: "Quantity",
      category: "Customer type",
      categories: ["Pilates Studio", "Physiotherapy", "Personal Trainer", "Hotel / Wellness", "Private client", "Other"],
      studioPackage: "Complete studio fit-out",
      select: "Please select",
      contactData: "Contact details",
      firstName: "First name",
      lastName: "Last name",
      company: "Company / Studio",
      email: "Email",
      phone: "Phone",
      location: "ZIP / City",
      message: "Message",
      submit: "Request an individual quote",
    },
    thanks: {
      title: ["THANK", "YOU."],
      text: "We have received your enquiry and will get back to you personally.",
      home: "Back to homepage",
    },
    admin: {
      overline: "Internal",
      loginTitle: "Admin Login",
      email: "Email",
      password: "Password",
      loginBtn: "Sign in",
      loginError: "Login failed. Please check your credentials.",
      dashboard: "Enquiries",
      logout: "Sign out",
      filterAll: "All",
      filterQuote: "Quotes",
      filterStudio: "Studio",
      filterContact: "Contact",
      statuses: { new: "New", contacted: "In contact", offered: "Quote sent", closed: "Closed" },
      empty: "No enquiries yet.",
      exportCsv: "CSV export",
      received: "Received",
      quantity: "Quantity",
      items: "Products",
      loadError: "Enquiries could not be loaded.",
    },
    legal: {
      placeholderBox:
        "PLACEHOLDER — This page will be completed with the legally required information before publication. No company data has been entered yet, deliberately.",
      impressum: { title: ["IMPRINT"], note: "Legal notice according to § 5 TMG to follow." },
      datenschutz: { title: ["PRIVACY", "POLICY"], note: "Privacy policy according to GDPR to follow." },
      agb: { title: ["TERMS"], note: "Terms and conditions to follow." },
      widerruf: { title: ["CANCELLATION", "POLICY"], note: "Cancellation policy to follow." },
    },
    seo: {
      home: ["PILATES ON. — Premium Pilates Reformers & Pilates Equipment", "Premium pilates reformers and pilates apparatus for studios, physiotherapy and professional training spaces. PILATES ON. WORLD OFF."],
      reformer: ["Pilates Reformers — Classic, Tower & Combo Cadillac | PILATES ON.", "Pilates reformers in solid hornbeam wood in five editions. Request a quote – price on request."],
      equipment: ["Pilates Equipment — Ladder Barrel, Combo Chair, Springwall, Spine Corrector | PILATES ON.", "Pilates equipment for studios: Ladder Barrel, Combo Chair, Springwall and Spine Corrector. Request a quote."],
      studios: ["Pilates Studio Equipment — For Studios | PILATES ON.", "Pilates studio equipment for studios, physiotherapy practices, personal trainers and hotels. Reformers, editions, quantity – request your project."],
      about: ["About us | PILATES ON.", "The philosophy behind PILATES ON.: movement, design, quality, function and aesthetics."],
      contact: ["Contact | PILATES ON.", "Questions about pilates reformers or studio projects? Get in touch – we reply personally."],
      inquiry: ["Request a quote | PILATES ON.", "Request an individual quote for pilates reformers and equipment – choose product, edition and quantity."],
    },
    footer: {
      tagline: "Premium Pilates Equipment.",
      menuCol: "Menu",
      legalCol: "Legal",
      contactCol: "Contact",
      note: "Images are illustrative – colours may vary. All prices on request.",
      admin: "Admin",
      rights: "© 2026 PILATES ON. All rights reserved.",
      legal: { impressum: "Imprint", datenschutz: "Privacy", agb: "Terms", widerruf: "Right of withdrawal" },
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      reformer: "Reformer",
      equipment: "Équipement",
      studios: "Pour les studios",
      about: "À propos",
      contact: "Contact",
      cta: "Demander un devis",
      menu: "Menu",
      close: "Fermer",
    },
    common: {
      quote: "Demander un devis",
      details: "Voir les détails",
      back: "Retour",
      material: "Matériau",
      dims: "Dimensions",
      finishesLabel: "Éditions",
      edition: "Édition",
      outfitting: "Équipement",
      priceOnRequest: "Prix sur demande",
      discover: "Découvrir {x}",
      onRequest: "Sur demande",
      placeholder: "Espace réservé",
      required: "Champ obligatoire",
      sending: "Envoi en cours …",
      formError: "Une erreur est survenue. Veuillez réessayer.",
      invalidEmail: "Veuillez saisir une adresse e-mail valide.",
    },
    home: {
      heroLines: ["PILATES ON.", "WORLD OFF."],
      heroSub: "Équipement Pilates premium pour les studios.",
      heroCtaPrimary: "Pour les studios",
      heroCtaSecondary: "Demander un devis",
      scroll: "Défiler",
      marquee: ["PILATES ON.", "WORLD OFF.", "DESIGNED FOR MOVEMENT.", "CRAFTED FOR SPACE."],
      philosophyOverline: "Philosophie",
      philosophyTitle: ["PILATES ON.", "WORLD OFF."],
      philosophyLead: "Un instant où seul le mouvement compte.",
      philosophyText:
        "PILATES ON. associe un équipement Pilates haut de gamme à une esthétique claire et un design réfléchi. Pour les studios, les espaces d'entraînement professionnels et celles et ceux qui accordent autant d'importance au mouvement qu'au design.",
      philosophyLink: "À propos",
      reformerOverline: "Reformer",
      reformerTitle: ["THE", "REFORMER."],
      reformerText: "Classic, Tower et Combo Cadillac. Bois de charme massif, lignes épurées – en cinq éditions.",
      reformerCta: "Découvrir les Reformers",
      editionsOverline: "Éditions",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "Cinq finitions, un Reformer. L'édition définit la couleur et le matériau – le modèle et la technique restent identiques.",
      studiosOverline: "Pour les studios",
      studiosTitle: ["MADE FOR", "STUDIOS."],
      studiosText:
        "Du premier Reformer à l'équipement complet du studio : nous équipons studios de Pilates, cabinets de physiothérapie, coachs personnels, hôtels et espaces bien-être – avec un design cohérent, trois modèles de Reformer en cinq éditions et un conseil personnalisé.",
      studiosCta: "Demander l'équipement de studio",
      studiosLink: "Plus pour les studios",
      ctaOverline: "Demande",
      ctaTitle: ["DEMANDER", "UN DEVIS."],
      ctaText: "Parlez-nous de votre espace et de vos besoins – nous vous répondons personnellement.",
      ctaBtn: "Demander un devis",
    },
    reformer: {
      overline: "Reformer",
      title: ["REFORMER"],
      sub: "Designed for movement.",
      intro: "Trois modèles. Bois de charme massif. Cinq éditions.",
      modelsOverline: "Modèles",
      editionsOverline: "Éditions",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "L'édition définit la couleur et le matériau – le modèle et la technique restent identiques.",
      hint: "La sélection s'applique à tous les modèles. Les couleurs peuvent différer de l'affichage.",
      shown: "Présenté",
    },
    detail: {
      back: "Tous les Reformers",
      chooseFinish: ["CHOOSE YOUR", "EDITION."],
      finishHint: "Le modèle et l'édition sont automatiquement repris dans votre demande.",
      selected: "Sélectionné",
      gallery: "Galerie",
      galleryHint: "Toutes les éditions en un coup d'œil – un clic sélectionne l'édition.",
      details: "Caractéristiques techniques",
      specsNote: "Autres détails d'équipement sur demande.",
      craftOverline: "Qualité & matériaux",
      craftTitle: ["CRAFTED", "FOR MOVEMENT."],
      offerOverline: "Demande",
      offerTitle: ["PRIX SUR", "DEMANDE."],
      offerText: "Pas de prix catalogue : vous recevez une offre personnalisée – adaptée à la quantité, à l'édition et à votre projet.",
      offerBtn: "Demander un devis",
    },
    equipment: {
      overline: "Équipement",
      title: ["MORE THAN", "REFORMER."],
      sub: "Ladder Barrel, Combo Chair, Springwall et Spine Corrector – dans le même langage formel que nos Reformers.",
      enquire: "Demander un devis",
      specs: "Caractéristiques techniques",
    },
    studios: {
      overline: "Pour les studios",
      title: ["YOUR STUDIO.", "YOUR WAY."],
      heroText: "Un équipement pour les espaces professionnels. Nouveau studio ou extension – nous vous accompagnons dans le choix de l'équipement adapté.",
      audiencesOverline: "Pour qui",
      audiences: ["Studios de Pilates", "Cabinets de physiothérapie", "Coachs personnels", "Hôtels", "Espaces bien-être", "Espaces d'entraînement professionnels"],
      focusOverline: "Ce qui compte",
      focus: [
        { t: "ÉQUIPEMENT PROFESSIONNEL", d: "Reformers et appareils en bois de charme massif – pour un usage quotidien en studio." },
        { t: "UNE IMAGE COHÉRENTE", d: "Tous les modèles dans la même édition – pour un design de studio calme et homogène." },
        { t: "CONSEIL PERSONNALISÉ", d: "Choix du produit, de l'édition et de la quantité – adaptés à votre espace et à votre concept." },
      ],
      processOverline: "Le chemin vers votre devis",
      steps: [
        { n: "01", t: "CHOISIR LE REFORMER", d: "Classic, Tower ou Combo Cadillac – adapté à l'espace et au concept." },
        { n: "02", t: "CHOISIR L'ÉDITION", d: "Natural, Walnut, Ivory, Obsidian ou Blush – une édition pour votre studio." },
        { n: "03", t: "DÉFINIR LA QUANTITÉ", d: "Du Reformer unique à l'équipement complet." },
        { n: "04", t: "DEMANDER UN PROJET", d: "Vous recevez une offre personnalisée pour votre projet." },
      ],
      editionsOverline: "Éditions",
      editionsTitle: ["UNE ÉDITION.", "UN STUDIO."],
      editionsText: "Tous les modèles de Reformer sont disponibles en cinq éditions – pour une image de studio homogène.",
      cta: "Demander un projet",
      formOverline: "Demande de projet",
      formTitle: ["PARLEZ-NOUS DE", "VOTRE PROJET."],
      firstName: "Prénom",
      lastName: "Nom",
      company: "Entreprise / Studio",
      email: "E-mail",
      phone: "Téléphone",
      location: "Ville / Code postal",
      needed: "De quoi avez-vous besoin ?",
      quantity: "Quantité souhaitée",
      opening: "Date d'ouverture prévue / calendrier",
      message: "Message",
      submit: "Demander un projet",
    },
    about: {
      overline: "À propos",
      title: ["MOVEMENT.", "DESIGN.", "QUALITY."],
      p1: "PILATES ON. incarne un équipement Pilates qui relie mouvement et design.",
      p2: "Nous pensons qu'un équipement professionnel ne doit pas seulement fonctionner, mais faire partie de l'espace – précis dans la fonction, calme dans la forme.",
      p3: "C'est pourquoi nous misons sur des Reformers en bois de charme massif, réduisons à l'essentiel et conseillons personnellement. Pour les studios, les espaces d'entraînement professionnels et celles et ceux qui accordent autant d'importance au mouvement qu'au design.",
      principlesOverline: "Ce que nous défendons",
      principles: [
        { t: "MOUVEMENT", d: "Un équipement qui met le mouvement au centre – et laisse tout le reste s'apaiser." },
        { t: "DESIGN", d: "Des lignes épurées et des matériaux chaleureux qui s'intègrent à chaque espace." },
        { t: "QUALITÉ", d: "Bois de charme massif, assemblages et rembourrages soigneusement réalisés." },
        { t: "FONCTION", d: "Trois modèles de Reformer et des appareils complémentaires pour un entraînement professionnel." },
        { t: "ESTHÉTIQUE", d: "Cinq éditions, une exigence : moins, mais mieux." },
      ],
      captions: ["Bois de charme", "Rembourrage", "Studio", "Combo Cadillac Reformer"],
      cta: "Nous contacter",
    },
    contact: {
      overline: "Contact",
      title: ["CONTACT."],
      sub: "Des questions sur les produits ou les projets ? Nous vous répondons personnellement – en allemand, en anglais ou en français.",
      name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      company: "Entreprise",
      message: "Message",
      submit: "Envoyer la demande",
      infoTitle: "Ligne directe",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
      address: "Siège social",
      emailValue: "office@pilateson.de",
      addressValue: "Kapellenstraße 55\n88471 Laupheim\nAllemagne",
    },
    inquiry: {
      overline: "Offre personnalisée",
      title: ["DEMANDER", "UN DEVIS."],
      sub: "Sans engagement et personnel – nous revenons vers vous avec une offre sur mesure.",
      summary: "Votre sélection",
      noProduct: "Aucun produit sélectionné",
      product: "Produit",
      finish: "Édition",
      quantity: "Quantité",
      category: "Type de client",
      categories: ["Studio de Pilates", "Physiothérapie", "Coach personnel", "Hôtel / Bien-être", "Client privé", "Autre"],
      studioPackage: "Équipement complet de studio",
      select: "Veuillez choisir",
      contactData: "Coordonnées",
      firstName: "Prénom",
      lastName: "Nom",
      company: "Entreprise / Studio",
      email: "E-mail",
      phone: "Téléphone",
      location: "Code postal / Ville",
      message: "Message",
      submit: "Demander une offre personnalisée",
    },
    thanks: {
      title: ["MERCI", "BEAUCOUP."],
      text: "Nous avons bien reçu votre demande et vous répondrons personnellement.",
      home: "Retour à l'accueil",
    },
    admin: {
      overline: "Interne",
      loginTitle: "Connexion admin",
      email: "E-mail",
      password: "Mot de passe",
      loginBtn: "Se connecter",
      loginError: "Échec de la connexion. Veuillez vérifier vos identifiants.",
      dashboard: "Demandes",
      logout: "Se déconnecter",
      filterAll: "Toutes",
      filterQuote: "Devis",
      filterStudio: "Studio",
      filterContact: "Contact",
      statuses: { new: "Nouveau", contacted: "En contact", offered: "Offre envoyée", closed: "Terminé" },
      empty: "Aucune demande pour le moment.",
      exportCsv: "Export CSV",
      received: "Reçue le",
      quantity: "Quantité",
      items: "Produits",
      loadError: "Impossible de charger les demandes.",
    },
    legal: {
      placeholderBox:
        "ESPACE RÉSERVÉ — Cette page sera complétée avant publication avec les mentions légales requises. Aucune donnée d'entreprise n'est encore renseignée intentionnellement.",
      impressum: { title: ["MENTIONS", "LÉGALES"], note: "Mentions légales à venir." },
      datenschutz: { title: ["POLITIQUE DE", "CONFIDENTIALITÉ"], note: "Politique de confidentialité conforme au RGPD à venir." },
      agb: { title: ["CGV"], note: "Conditions générales de vente à venir." },
      widerruf: { title: ["DROIT DE", "RÉTRACTATION"], note: "Informations sur le droit de rétractation à venir." },
    },
    seo: {
      home: ["PILATES ON. — Reformers Pilates & équipement Pilates premium", "Reformers Pilates et appareils Pilates premium pour studios, physiothérapie et espaces d'entraînement professionnels. PILATES ON. WORLD OFF."],
      reformer: ["Reformers Pilates — Classic, Tower & Combo Cadillac | PILATES ON.", "Reformers Pilates en bois de charme massif, en cinq éditions. Demander un devis – prix sur demande."],
      equipment: ["Équipement Pilates — Ladder Barrel, Combo Chair, Springwall, Spine Corrector | PILATES ON.", "Équipement Pilates pour studios : Ladder Barrel, Combo Chair, Springwall et Spine Corrector. Demander un devis."],
      studios: ["Équipement de studio Pilates — Pour les studios | PILATES ON.", "Équipement de studio Pilates pour studios, cabinets de physiothérapie, coachs personnels et hôtels. Reformers, éditions, quantité – demander un projet."],
      about: ["À propos | PILATES ON.", "La philosophie de PILATES ON. : mouvement, design, qualité, fonction et esthétique."],
      contact: ["Contact | PILATES ON.", "Des questions sur les Reformers Pilates ou les projets de studio ? Contactez-nous – nous répondons personnellement."],
      inquiry: ["Demander un devis | PILATES ON.", "Demander une offre personnalisée pour Reformers et équipement Pilates – choisir le produit, l'édition et la quantité."],
    },
    footer: {
      tagline: "Équipement Pilates premium.",
      menuCol: "Menu",
      legalCol: "Mentions légales",
      contactCol: "Contact",
      note: "Images à titre d'exemple – les couleurs peuvent varier. Tous les prix sur demande.",
      admin: "Admin",
      rights: "© 2026 PILATES ON. Tous droits réservés.",
      legal: { impressum: "Mentions légales", datenschutz: "Confidentialité", agb: "CGV", widerruf: "Rétractation" },
    },
  },
  es: {
    nav: { home: "Inicio", reformer: "Reformer", equipment: "Equipamiento", studios: "Para estudios", about: "Sobre nosotros", contact: "Contacto", cta: "Solicitar oferta", menu: "Menú", close: "Cerrar" },
    common: {
      quote: "Solicitar oferta", details: "Ver detalles", back: "Volver", material: "Material", dims: "Dimensiones",
      finishesLabel: "Ediciones", edition: "Edición", outfitting: "Equipamiento", priceOnRequest: "Precio bajo consulta",
      discover: "Descubrir {x}", onRequest: "Bajo consulta", placeholder: "Marcador", required: "Campo obligatorio",
      sending: "Enviando …", formError: "Se ha producido un error. Inténtalo de nuevo.", invalidEmail: "Introduce una dirección de correo válida.",
    },
    home: {
      heroLines: ["PILATES ON.", "WORLD OFF."],
      heroSub: "Equipamiento Pilates premium para estudios.",
      heroCtaPrimary: "Para estudios",
      heroCtaSecondary: "Solicitar oferta",
      scroll: "Desplazar",
      marquee: ["PILATES ON.", "WORLD OFF.", "MADE FOR STUDIOS.", "DESIGNED FOR MOVEMENT.", "CRAFTED FOR SPACE."],
      philosophyOverline: "Filosofía",
      philosophyTitle: ["PILATES ON.", "WORLD OFF."],
      philosophyLead: "Un instante en el que solo cuenta el movimiento.",
      philosophyText: "PILATES ON. une equipamiento Pilates de alta calidad con una estética clara y un diseño meditado. Para estudios, espacios de entrenamiento profesionales y personas que valoran por igual el movimiento y el diseño.",
      philosophyLink: "Sobre nosotros",
      reformerOverline: "Reformer",
      reformerTitle: ["THE", "REFORMER."],
      reformerText: "Classic, Tower y Combo Cadillac. Madera de carpe maciza, líneas claras – en cinco ediciones.",
      reformerCta: "Descubrir los Reformers",
      editionsOverline: "Ediciones",
      editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "Cinco acabados, un Reformer. La edición define color y material – modelo y técnica permanecen idénticos.",
      studiosOverline: "Para estudios",
      studiosTitle: ["MADE FOR", "STUDIOS."],
      studiosText: "Del primer Reformer al equipamiento completo del estudio: equipamos estudios de Pilates, consultas de fisioterapia, entrenadores personales, hoteles y zonas wellness – con un diseño coherente, tres modelos de Reformer en cinco ediciones y asesoramiento personal.",
      studiosCta: "Solicitar equipamiento de estudio",
      studiosLink: "Más para estudios",
      ctaOverline: "Solicitud",
      ctaTitle: ["SOLICITAR", "OFERTA."],
      ctaText: "Cuéntanos sobre tu espacio y tus necesidades – te respondemos personalmente.",
      ctaBtn: "Solicitar oferta",
    },
    reformer: {
      overline: "Reformer", title: ["REFORMER"], sub: "Designed for movement.", intro: "Tres modelos. Madera de carpe maciza. Cinco ediciones.",
      modelsOverline: "Modelos", editionsOverline: "Ediciones", editionsTitle: ["CHOOSE YOUR", "EDITION."],
      editionsText: "La edición define color y material – modelo y técnica permanecen idénticos.",
      hint: "La selección se aplica a todos los modelos. Los colores pueden variar respecto a la pantalla.", shown: "Mostrado",
    },
    detail: {
      back: "Todos los Reformers", chooseFinish: ["CHOOSE YOUR", "EDITION."],
      finishHint: "Modelo y edición se incorporan automáticamente a tu solicitud.", selected: "Seleccionado",
      gallery: "Galería", galleryHint: "Todas las ediciones de un vistazo – un clic selecciona la edición.",
      details: "Datos técnicos", specsNote: "Más detalles de equipamiento bajo consulta.",
      craftOverline: "Calidad y materiales", craftTitle: ["CRAFTED", "FOR MOVEMENT."],
      offerOverline: "Solicitud", offerTitle: ["PRECIO BAJO", "CONSULTA."],
      offerText: "Sin precios de lista: recibes una oferta personal – ajustada a cantidad, edición y proyecto.", offerBtn: "Solicitar oferta",
    },
    equipment: {
      overline: "Equipamiento", title: ["MORE THAN", "REFORMER."],
      sub: "Ladder Barrel, Combo Chair, Springwall y Spine Corrector – con el mismo lenguaje formal que nuestros Reformers.",
      enquire: "Solicitar oferta", specs: "Datos técnicos",
    },
    studios: {
      overline: "Para estudios", title: ["YOUR STUDIO.", "YOUR WAY."],
      heroText: "Equipamiento para espacios profesionales. Nuevo estudio o ampliación – te acompañamos en la elección del equipamiento adecuado.",
      audiencesOverline: "Para quién",
      audiences: ["Estudios de Pilates", "Consultas de fisioterapia", "Entrenadores personales", "Hoteles", "Zonas wellness", "Espacios de entrenamiento profesionales"],
      focusOverline: "Lo que importa",
      focus: [
        { t: "EQUIPAMIENTO PROFESIONAL", d: "Reformers y aparatos en madera de carpe maciza – para el uso diario en el estudio." },
        { t: "UNA IMAGEN COHERENTE", d: "Todos los modelos en la misma edición – para un diseño de estudio sereno y uniforme." },
        { t: "ASESORAMIENTO PERSONAL", d: "Selección de producto, edición y cantidad – ajustadas a tu espacio y concepto." },
      ],
      processOverline: "El camino hacia tu oferta",
      steps: [
        { n: "01", t: "ELEGIR REFORMER", d: "Classic, Tower o Combo Cadillac – según espacio y concepto." },
        { n: "02", t: "ELEGIR EDICIÓN", d: "Natural, Walnut, Ivory, Obsidian o Blush – una edición para tu estudio." },
        { n: "03", t: "DEFINIR CANTIDAD", d: "Desde un solo Reformer hasta el equipamiento completo." },
        { n: "04", t: "SOLICITAR PROYECTO", d: "Recibes una oferta individual para tu proyecto." },
      ],
      editionsOverline: "Ediciones", editionsTitle: ["UNA EDICIÓN.", "UN ESTUDIO."],
      editionsText: "Todos los modelos de Reformer están disponibles en cinco ediciones – para una imagen de estudio coherente.",
      cta: "Solicitar proyecto", formOverline: "Solicitud de proyecto", formTitle: ["CUÉNTANOS SOBRE", "TU PROYECTO."],
      firstName: "Nombre", lastName: "Apellidos", company: "Empresa / Estudio", email: "Correo electrónico", phone: "Teléfono",
      location: "Ciudad / Código postal", needed: "¿Qué necesitas?", quantity: "Cantidad deseada", opening: "Fecha de apertura prevista / plazo",
      message: "Mensaje", submit: "Solicitar proyecto",
    },
    about: {
      overline: "Sobre nosotros", title: ["MOVEMENT.", "DESIGN.", "QUALITY."],
      p1: "PILATES ON. representa equipamiento Pilates que une movimiento y diseño.",
      p2: "Creemos que el equipamiento profesional no solo debe funcionar, sino formar parte del espacio – preciso en la función, sereno en la forma.",
      p3: "Por eso apostamos por Reformers de madera de carpe maciza, reducimos a lo esencial y asesoramos personalmente. Para estudios, espacios de entrenamiento profesionales y personas que valoran por igual el movimiento y el diseño.",
      principlesOverline: "Lo que defendemos",
      principles: [
        { t: "MOVIMIENTO", d: "Equipamiento que centra la atención en el movimiento – y deja que todo lo demás se aquiete." },
        { t: "DISEÑO", d: "Líneas claras y materiales cálidos que se integran en cualquier espacio." },
        { t: "CALIDAD", d: "Madera de carpe maciza, uniones y tapicería cuidadosamente elaboradas." },
        { t: "FUNCIÓN", d: "Tres modelos de Reformer y aparatos complementarios para el entrenamiento profesional." },
        { t: "ESTÉTICA", d: "Cinco ediciones, una exigencia: menos, pero mejor." },
      ],
      captions: ["Madera de carpe", "Tapicería", "Estudio", "Combo Cadillac Reformer"], cta: "Contactar",
    },
    contact: {
      overline: "Contacto", title: ["CONTACTO."],
      sub: "¿Preguntas sobre productos o proyectos? Te respondemos personalmente – en alemán, inglés, francés o español.",
      name: "Nombre", email: "Correo electrónico", phone: "Teléfono", company: "Empresa", message: "Mensaje", submit: "Enviar solicitud",
      infoTitle: "Línea directa", emailLabel: "Correo electrónico", phoneLabel: "Teléfono", address: "Sede",
      emailValue: "office@pilateson.de", addressValue: "Kapellenstraße 55\n88471 Laupheim\nAlemania",
    },
    inquiry: {
      overline: "Oferta personalizada", title: ["SOLICITAR", "OFERTA."],
      sub: "Sin compromiso y personal – volvemos a ti con una oferta a medida.",
      summary: "Tu selección", noProduct: "Ningún producto seleccionado", product: "Producto", finish: "Edición", quantity: "Cantidad", category: "Tipo de cliente",
      categories: ["Estudio de Pilates", "Fisioterapia", "Entrenador personal", "Hotel / Wellness", "Cliente particular", "Otro"],
      studioPackage: "Equipamiento completo de estudio", select: "Selecciona", contactData: "Datos de contacto",
      firstName: "Nombre", lastName: "Apellidos", company: "Empresa / Estudio", email: "Correo electrónico", phone: "Teléfono",
      location: "Código postal / Ciudad", message: "Mensaje", submit: "Solicitar oferta personalizada",
    },
    thanks: { title: ["MUCHAS", "GRACIAS."], text: "Hemos recibido tu solicitud y te responderemos personalmente.", home: "Volver al inicio" },
    admin: {
      overline: "Interno", loginTitle: "Acceso admin", email: "Correo electrónico", password: "Contraseña", loginBtn: "Iniciar sesión",
      loginError: "Error de acceso. Comprueba tus datos.", dashboard: "Solicitudes", logout: "Cerrar sesión",
      filterAll: "Todas", filterQuote: "Ofertas", filterStudio: "Estudio", filterContact: "Contacto",
      statuses: { new: "Nueva", contacted: "En contacto", offered: "Oferta enviada", closed: "Cerrada" },
      empty: "Todavía no hay solicitudes.", exportCsv: "Exportar CSV", received: "Recibida el", quantity: "Cantidad", items: "Productos", loadError: "No se pudieron cargar las solicitudes.",
    },
    legal: {
      placeholderBox: "MARCADOR — Esta página se completará antes de la publicación con la información legal requerida.",
      impressum: { title: ["AVISO", "LEGAL"], note: "Aviso legal próximamente." },
      datenschutz: { title: ["POLÍTICA DE", "PRIVACIDAD"], note: "Política de privacidad conforme al RGPD próximamente." },
      agb: { title: ["CONDICIONES", "GENERALES"], note: "Condiciones generales próximamente." },
      widerruf: { title: ["DERECHO DE", "DESISTIMIENTO"], note: "Información sobre el derecho de desistimiento próximamente." },
    },
    seo: {
      home: ["PILATES ON. — Reformers Pilates y equipamiento Pilates premium", "Reformers Pilates y aparatos Pilates premium para estudios, fisioterapia y espacios de entrenamiento profesionales. PILATES ON. WORLD OFF."],
      reformer: ["Reformers Pilates — Classic, Tower & Combo Cadillac | PILATES ON.", "Reformers Pilates de madera de carpe maciza en cinco ediciones. Solicitar oferta – precio bajo consulta."],
      equipment: ["Equipamiento Pilates — Ladder Barrel, Combo Chair, Springwall, Spine Corrector | PILATES ON.", "Equipamiento Pilates para estudios: Ladder Barrel, Combo Chair, Springwall y Spine Corrector. Solicitar oferta."],
      studios: ["Equipamiento para estudios de Pilates — Para estudios | PILATES ON.", "Equipamiento de estudio Pilates para estudios, consultas de fisioterapia, entrenadores personales y hoteles. Reformers, ediciones, cantidad – solicitar proyecto."],
      about: ["Sobre nosotros | PILATES ON.", "La filosofía de PILATES ON.: movimiento, diseño, calidad, función y estética."],
      contact: ["Contacto | PILATES ON.", "¿Preguntas sobre Reformers Pilates o proyectos de estudio? Contáctanos – respondemos personalmente."],
      inquiry: ["Solicitar oferta | PILATES ON.", "Solicita una oferta personalizada para Reformers y equipamiento Pilates – elige producto, edición y cantidad."],
    },
    footer: {
      tagline: "Equipamiento Pilates premium.", menuCol: "Menú", legalCol: "Legal", contactCol: "Contacto",
      note: "Imágenes a modo de ejemplo – los colores pueden variar. Todos los precios bajo consulta.", admin: "Admin",
      rights: "© 2026 PILATES ON. Todos los derechos reservados.",
      legal: { impressum: "Aviso legal", datenschutz: "Privacidad", agb: "Condiciones", widerruf: "Desistimiento" },
    },
  },
};
